exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-menu{display:none}@media screen and (min-width:63em){.user-menu{position:relative;display:block;height:1.3125rem;white-space:nowrap}.user-menu .thumbnail{height:1.3125rem;width:1.3125rem;padding:0;border-radius:50%}.user-menu .default-thumbnail{background:transparent}.user-menu .default-thumbnail svg{height:100%;width:100%}.user-menu .default-thumbnail path{fill:#b0b8bf}.user-menu__trigger{display:flex;align-items:center;color:#b0b8bf;cursor:default}.user-menu__email{margin:0 .5rem;font-size:.75rem;font-weight:300}.user-menu__open{height:.75rem}.user-menu__open path{fill:#b0b8bf}.user-menu .action-menu{right:.5rem}.user-menu .user-details__header{padding:.75rem}.user-menu .user-details__info{margin:0;padding:.75rem}.user-menu .user-details__email{font-size:.875rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserMenu/UserMenu.scss
// module id = 695
// module chunks = 0